import { Point } from '../utils/point';
import { Cutting } from '../cutting';

export class ConfigurationCutting {
  // Info basique
  id: string;
  displayOrder: number;

  // Ids
  cuttingId: number;
  configurationPlanId: string;
  configurationSplashbackId: string;

  // Jointure
  cutting: Cutting;
  origin: Point;

  // Rotation state 0-3 (quarter turns), persisted in DB
  rotationState?: number;

  constructor(displayOrder: number) {
    this.displayOrder = displayOrder;
  }
}
